import './checkboxView.less'
import { randHex } from '../../utils/mathUtils'
import { CheckSquare as SvgCheckSquare, Square as SvgSquare } from 'phosphor-react'
import React from 'react'
import { Typography } from '@lightbeamai/design-system'

interface IProps {
  checked: boolean
  content?: string | number | boolean | React.ReactElement
  name?: string
  disabled?: boolean
  className?: string
  value?: string
  required?: boolean
  testId?: string
  colorCheckbox?: string
  onChange: (event: React.FormEvent<HTMLInputElement>) => void
}

const CheckboxView = (props: IProps) => {
  const {
    checked,
    content = '',
    disabled = false,
    value,
    className = '',
    name = '',
    required = false,
    testId,
    colorCheckbox = '',
    onChange
  } = props
  const inputId = name ? name : randHex(3)

  return (
    <div
      className={`checkbox-custom ${disabled ? 'disabled' : ''} ${className}`}
      data-test-id="checkbox-view"
    >
      <input
        id={inputId}
        name={name || inputId}
        checked={checked}
        disabled={disabled}
        onChange={onChange}
        type="checkbox"
        {...(value ? { value } : {})}
        {...(testId ? { 'data-test-id': testId } : {})}
        hidden
      />
      <label
        htmlFor={inputId}
        className={`checkbox-custom-label ${required ? 'show-required' : ''}`}
      >
        <div className="icon-box">
          {checked ? (
            <SvgCheckSquare
              size={22}
              color={
                disabled ? '#d1d5da' : colorCheckbox ? colorCheckbox : 'var(--color-primary-light)'
              }
              weight="fill"
            />
          ) : (
            <SvgSquare size={22} color={colorCheckbox ? colorCheckbox : '#B6BCC2'} weight="thin" />
          )}
        </div>
        <div className="content">
          <Typography variant="baseMinus2" color="secondary" as="span">
            {content}
          </Typography>
        </div>
      </label>
    </div>
  )
}

export default CheckboxView
